<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { getUserActivity } from '../api/users';

export default {
  name: 'CpProfileActivity',
  components: {
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpBox: require('../box').default,
    CpBoxContent: require('../box-content').default,
    CpPageContent: require('../page-content.vue').default,
    CpTabs: require('../inputs/tabs').default,
    CpTab: require('../inputs/tab').default,
    CpSliceToggle: require('../inputs/SliceToggle').default,
    CpSupportedActivity: require('./activity-content/SupportedActivity').default,
    CpYourActivity: require('./activity-content/YourActivity').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    user: Object,
    recipients: Array,
  },
  data() {
    return {
      currentTab: 'activity',
      activities: [],
      loading: false,
      page: 0,
    };
  },
  created() {
    const url = new URL(window.location.href);
    const hash = url.hash;
    if (hash && hash === '#supported') {
      this.currentTab = 'supported';
    }
  },
  computed: {
    isViewingSelf() {
      return this.isUserLogin && this.userLoginData.id === Number(this.user.id);
    },
    ...mapState(useUserStore, ['isUserLogin', 'userLoginData']),
  },
  methods: {
    async getActivities($state = { loaded: () => {}, complete: () => {} }) {
      this.loading = true;
      await getUserActivity(this.user.slug, { page: this.page })
        .then(response => {
          if (response.activities.length) {
            this.activities = this.activities.concat(response.activities);
            this.page += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <CpPageContent>
    <CpTabs spaceBetween>
      <CpTab :name="isViewingSelf ? 'Your activity' : 'Recent activity'" :selected="currentTab == 'activity'">
        <CpYourActivity :user="user" :getActivities="getActivities" :activities="activities" :loading="loading" />
      </CpTab>
      <CpTab name="Supported" :selected="currentTab == 'supported'">
        <CpSupportedActivity :user="user" :recipients="recipients" />
      </CpTab>
    </CpTabs>
  </CpPageContent>
</template>

<style scoped>
</style>
